import {Link, useNavigate, useParams} from 'react-router-dom'
import {KTIcon, KTSVG} from '../../../../_metronic/helpers'
import {useEffect, useState, useCallback} from 'react'
import {
  deleteInterview,
  getInterviewWithProject,
  getInterviewById,
  getProject,
  postDuplicateInterview,
} from '../_requets'
import {Spinner} from 'react-bootstrap'
import {useAuth} from '../../../modules/auth'
import {useSelector, useDispatch} from 'react-redux'
import {RootState} from '../../../redux/store'
import {setProjects} from '../../../redux/project/projectSlice'
import {
  setInterviewData,
  deleteInterview as removeInterviewFromStore,
  addInterview,
} from '../../../redux/interview/interviewSlice'
import Filter from '../../../utils/Filter'
import Swal from 'sweetalert2'

const InterviewPage = () => {
  const PAGE_SIZE = 100 // Items per page
  const [deleteid, setdeleteid] = useState<string>('')
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {projectid} = useParams()
  const [filteredData, setFilteredData] = useState([])
  const loadingProject = useSelector((state: RootState) => state.project.loading)
  const tableData = useSelector((state: RootState) => state.interview.interviewData)
  const {
    totalDocs: totalDocsr,
    totalPages: totalPagesr,
    hasNextPage: hasNextPager,
    hasPrevPage: hasPrevPager,
  } = useSelector((state: RootState) => state.interview)
  const [, setInterviewDataLength] = useState(0)
  const handleNewInterviewRedirect = () => {
    navigate('/interview/create-interview')
  }
  const [loading, setLoading] = useState(true)
  const {currentUser} = useAuth()
  const [searchTerm, setSearchTerm] = useState('')
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)
  const [page, setPage] = useState(1)
  const [totalDocs, setTotalDocs] = useState(1)
  const [hasNextPage, setHasNextPage] = useState(true)
  const [hasPrevPage, setHasPrevPage] = useState(false)
  const [totalPages, setTotalPages] = useState(1)

  const getFilteredData = useCallback(async () => {
    setLoading(true)
    const res = await getInterviewWithProject(searchTerm, startDate, endDate, page, projectid)
    setFilteredData(res?.docs || res)
    setInterviewDataLength(res?.docs?.length || res.length)
    setTotalDocs(res?.totalDocs)
    setHasNextPage(res?.hasNextPage)
    setHasPrevPage(res?.hasPrevPage)
    setTotalPages(res?.totalPages)
    setLoading(false)
  }, [searchTerm, startDate, endDate, page])

  useEffect(() => {
    const fetchData = async () => {
      if (tableData?.length === 0) {
        if (currentUser?.profileType === 'admin') {
          const res = await getInterviewWithProject(
            undefined,
            undefined,
            undefined,
            page,
            projectid
          )
          dispatch(setInterviewData(res))
          setInterviewDataLength(res?.docs?.length || res.length)
          setFilteredData(res?.docs || res)
          setTotalDocs(res?.totalDocs)
          setHasNextPage(res?.hasNextPage)
          setHasPrevPage(res?.hasPrevPage)
          setTotalPages(res?.totalPages)
        } else {
          const res = await getInterviewById(currentUser?.fullName, projectid)
          dispatch(
            setInterviewData({
              docs: res,
              totalDocs: res.length,
              totalPages: 1,
              hasNextPage: false,
              hasPrevPage: false,
            })
          )
          setInterviewDataLength(res.length)
          setFilteredData(res)
          setTotalDocs(res?.length)
          setHasNextPage(false)
          setHasPrevPage(false)
          setTotalPages(1)
        }
      } else {
        setFilteredData(tableData)
        setInterviewDataLength(tableData.length)
        setTotalDocs(totalDocsr)
        setTotalPages(totalPagesr)
        setHasNextPage(hasNextPager)
        setHasPrevPage(hasPrevPager)
      }
      setLoading(false)
      if (loadingProject) {
        const res2 = await getProject()
        dispatch(setProjects(res2))
      }
    }

    fetchData()
  }, [])

  const formatCreatedAt = (createdAt: string | undefined) => {
    if (!createdAt) return 'N/A'
    const formattedDate = new Date(createdAt).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })
    return formattedDate
  }

  const handleDuplicate = async (id: string) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You wont to duplicate this interview!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, duplicate it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true)
        //
        const res = await postDuplicateInterview(id)
        if (res) {
          dispatch(addInterview(res))
          setLoading(false)
        }
      }
    })
  }

  const handleEdit = (id: string) => {
    navigate(`/interview/edit-interview/${id}`)
  }

  const handleDelete = async () => {
    const res = await deleteInterview(deleteid)
    // fetchData()
    if (res !== null) {
      dispatch(removeInterviewFromStore(deleteid))
      const closeModalButton = document.getElementById('closeModalButtondelete')
      if (closeModalButton) {
        closeModalButton.click()
      }
    }
  }

  useEffect(() => {
    if (startDate && endDate) {
      getFilteredData()
    }
  }, [endDate])

  useEffect(() => {
    if (searchTerm !== '') {
      getFilteredData()
    }
  }, [searchTerm])

  useEffect(() => {
    if (currentUser?.profileType === 'admin') {
      getFilteredData()
    }
  }, [page, currentUser?.profileType, getFilteredData])

  const resetFilter = () => {
    setSearchTerm('')
    setStartDate(null)
    setEndDate(null)
    setPage(1)
    setFilteredData(tableData)
    setInterviewDataLength(tableData.length)
  }

  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage)
    }
  }

  const handlePrevPage = () => {
    if (hasPrevPage) {
      setPage(page - 1)
    }
  }

  const handleNextPage = () => {
    if (hasNextPage) {
      setPage(page + 1)
    }
  }

  return (
    <section>
      <div className='flex flex-col px-8 py-6 card'>
        <h3 className='mb-6 text-lg font-semibold'>Interviews</h3>
        <div className='w-full rounded-lg md:mx-4 card'>
          <div className='flex items-center justify-between p-4'>
            <div className='flex flex-col md:flex-row items-center gap-4'>
              <h3 className='text-lg font-semibold'>Interviews</h3>
              {currentUser?.profileType === 'admin' && (
                <Filter
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                  resetFilter={resetFilter}
                />
              )}
            </div>
            {currentUser?.profileType === 'admin' && (
              <button onClick={handleNewInterviewRedirect} className='btn btn-success btn-sm'>
                <KTIcon iconName='plus' className='fs-3' />
                <span className='text-sm md:text-base hidden md:inline'>New Interview</span>
              </button>
            )}
          </div>
          <div className='card-body py-3'>
            <div className='table-responsive'>
              {loading ? (
                <>
                  <div className='w-full flex items-center justify-center'>
                    <Spinner animation='border' variant='primary' />
                  </div>
                </>
              ) : (
                <table className='table align-middle gs-0 gy-3'>
                  <thead>
                    <tr className='fw-bold text-muted bg-light'>
                      <th className='w-6 ps-4 rounded-start'>No.</th>
                      <th className='min-w-[300px]'>Name</th>
                      {/* <th className='min-w-[200px]'>Project</th> */}
                      <th className='min-w-[150px]'>Group</th>
                      <th className='min-w-[150px]'>Surveyors</th>
                      <th className='min-w-[150px]'>Clients</th>
                      <th className='min-w-[125px]'>Created On</th>
                      {currentUser?.profileType === 'admin' && (
                        <th className='min-w-[100px] rouunded-end'>Modify</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((data, index) => {
                      return (
                        <tr key={data._id}>
                          <td className='ps-4 font-semibold'>
                            {totalDocs - index - (page - 1) * PAGE_SIZE}
                          </td>
                          <td className='px-2 font-semibold capitalize'>
                            <Link
                              to={`/interview/questionnaire/${data?.questionnaireUI || 'default'}/${
                                data._id
                              }`}
                            >
                              {data.interviewName}
                            </Link>
                          </td>
                          {/* <td className='px-2 text-blue-400 capitalize'>
                            {
                              projectList.filter((item, i) => {
                                return item._id === data.project
                              })[0]?.name
                            }
                            {data?.project?.name}
                          </td> */}
                          <td className='px-2 font-semibold'>
                            <span className='badge badge-light-primary fs-7 fw-semibold me-2 capitalize'>
                              {data.group}
                            </span>
                          </td>
                          <td className='px-2 font-semibold'>
                            {data.surveyors.map((item, idx) => (
                              <span
                                className='badge badge-light-success fs-7 fw-semibold me-2 capitalize'
                                key={idx}
                              >
                                {item}
                              </span>
                            ))}
                          </td>
                          <td className='px-2 font-semibold'>
                            {data?.clients?.map((item, idx) => (
                              <span
                                className='badge badge-light-success fs-7 fw-semibold me-2 capitalize'
                                key={idx}
                              >
                                {item}
                              </span>
                            ))}
                          </td>

                          <td className='px-2 font-semibold'>{formatCreatedAt(data.createdAt)}</td>
                          {currentUser?.profileType === 'admin' && (
                            <td className='text-end'>
                              <div className='flex items-center justify-around gap-2 text-lg text-gray-700'>
                                <div
                                  className='cursor-pointer rounded-md bg-gray-200 p-2 flex items-center justify-center'
                                  onClick={() => handleDuplicate(data._id)}
                                >
                                  <KTIcon iconName='plus' className='fs-3' />
                                </div>
                                <div
                                  className='cursor-pointer rounded-md bg-gray-200 p-2 flex items-center justify-center'
                                  onClick={() => handleEdit(data._id)}
                                >
                                  <KTIcon iconName='pencil' className='fs-3' />
                                </div>
                                <div
                                  className='cursor-pointer rounded-md bg-gray-200 p-2 flex items-center justify-center'
                                  data-bs-toggle='modal'
                                  data-bs-target='#kt_modal_2'
                                  onClick={() => setdeleteid(data._id)}
                                >
                                  <KTIcon iconName='trash' className='fs-3' />
                                </div>
                              </div>
                            </td>
                          )}
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              )}
            </div>
            {/* Pagination Controls */}
            {currentUser?.profileType === 'admin' && totalPages > 1 && (
              <div className='d-flex justify-content-between align-items-center p-4'>
                <div className='text-muted'>
                  Showing {(page - 1) * PAGE_SIZE + 1} to {Math.min(page * PAGE_SIZE, totalDocs)} of{' '}
                  {totalDocs} entries
                </div>
                <div className='d-flex align-items-center gap-2'>
                  <button
                    className={`btn btn-sm ${hasPrevPage ? 'btn-light' : 'btn-light-secondary'}`}
                    onClick={handlePrevPage}
                    disabled={!hasPrevPage}
                  >
                    <KTIcon iconName='arrow-left' className='fs-3' />
                    Previous
                  </button>

                  <div className='d-flex align-items-center gap-1'>
                    {/* Show first page */}
                    {page > 3 && (
                      <>
                        <button
                          className='btn btn-sm btn-light'
                          onClick={() => handlePageChange(1)}
                        >
                          1
                        </button>
                        {page > 4 && <span className='px-2'>...</span>}
                      </>
                    )}

                    {/* Show pages around current page */}
                    {(() => {
                      const maxVisiblePages = 5
                      let startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2))
                      let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1)

                      // Adjust start page if we're near the end
                      if (endPage - startPage + 1 < maxVisiblePages) {
                        startPage = Math.max(1, endPage - maxVisiblePages + 1)
                      }

                      const pages = []
                      for (let i = startPage; i <= endPage; i++) {
                        // Skip if this page is already shown in first/last page sections
                        if ((i === 1 && page > 3) || (i === totalPages && page < totalPages - 2)) {
                          continue
                        }

                        pages.push(
                          <button
                            key={i}
                            className={`btn btn-sm ${i === page ? 'btn-primary' : 'btn-light'}`}
                            onClick={() => handlePageChange(i)}
                          >
                            {i}
                          </button>
                        )
                      }
                      return pages
                    })()}

                    {/* Show last page */}
                    {page < totalPages - 2 && (
                      <>
                        {page < totalPages - 3 && <span className='px-2'>...</span>}
                        <button
                          className='btn btn-sm btn-light'
                          onClick={() => handlePageChange(totalPages)}
                        >
                          {totalPages}
                        </button>
                      </>
                    )}
                  </div>

                  <button
                    className={`btn btn-sm ${hasNextPage ? 'btn-light' : 'btn-light-secondary'}`}
                    onClick={handleNextPage}
                    disabled={!hasNextPage}
                  >
                    Next
                    <KTIcon iconName='arrow-right' className='fs-3' />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='modal fade' tabIndex={-1} id='kt_modal_2'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Delete</h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>

            <div className='modal-body'>
              <h3> Are you sure you want to delete</h3>
            </div>

            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-light'
                data-bs-dismiss='modal'
                id='closeModalButtondelete'
              >
                No
              </button>
              <button type='button' className='btn btn-primary' onClick={handleDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default InterviewPage
